// extracted by mini-css-extract-plugin
export default {"root":"SelectPicker_root__5zZAJ"};